module.exports = __webpack_public_path__ + "static/media/bonus-game.9f7bd8a9.png";